module.exports = require("vuedraggable");